import { Pipe, PipeTransform } from '@angular/core';


// This pipe is a special purpose pipe for filtering items with favorites. 
// You get one filter- by column.Supporting k- orderby involves trees. 
@Pipe({
    name: 'myOrderBy'
})
export class OrderByPipe implements PipeTransform  {

    orderByComparator(a: any, b: any): number {

        if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
            // Isn't a number so lowercase the string to properly compare
            if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) { return -1; }
            if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) { return 1; }
        } else {
            // Parse strings as numbers to compare properly
            if (parseFloat(a) < parseFloat(b)) { return -1; }
            if (parseFloat(a) > parseFloat(b)) { return 1; }
        }

        return 0; // equal each other
    }
    // creating new transform method in case this one doesn't pan out without having to revert'
    // we want to sort by 'Favorite' and then sort by the column given
    transform(input: any, column: string, favoritedEvent?): any {
        if (!Array.isArray(input)) { return input; }

        let favorite = [];
        let notFavorite = [];

        input.forEach(x => {
            if (x.hasOwnProperty('Favorite') && x['Favorite']) {
                favorite.push(x);
            } else {
                notFavorite.push(x);
            }
        });

        let combined = Array.from(favorite).sort((item1: any, item2: any) => {
            return this.orderByComparator(item1[column], item2[column]);
        }).concat(Array.from(notFavorite).sort((item1: any, item2: any) => {
            return this.orderByComparator(item1[column], item2[column]);
        }));

        return combined;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/orderby.pipe.ts